import React from 'react';
import type FeaturesSettingsType from '@atlassian/jira-spa-apps-project-settings-next-gen-features/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyFeaturesSettings = lazyForPaint<typeof FeaturesSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-next-gen-features", jiraSpaEntry: "async-project-settings-next-gen-features" */ '@atlassian/jira-spa-apps-project-settings-next-gen-features'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyFeaturesSettings}
		pageId="project-settings-next-gen-features"
		shouldShowSpinner={false}
	/>
);
